import './style.css'
import React, { useEffect, useState } from 'react'
import imgLogo from '../../media/logo/logo.png'
import imgLogoMarketing from "../../media/img/home/logo_marketing.png";
import { GrMail } from "react-icons/gr";
import { FaFacebook, FaInstagram, FaLocationDot, FaPhone, FaTiktok, FaYoutube  } from 'react-icons/fa6'
import Copyright from '../copyright';

interface FooterProps{
  marketing?: boolean;
}

export default function Footer({marketing}: FooterProps) {
const [logo, setLogo] = useState(imgLogo);
const [instagram, setInstagram] = useState('');
const [whatsapp, setWhatsapp] = useState('');
const [telefono, setTelefono] = useState('');
const [email, setEmail] = useState('');

  useEffect(() => {
    let parametros = localStorage.getItem("parametros") ? JSON.parse(localStorage.getItem("parametros")!) : {};

    let instagramParametro = parametros?.instagram || '';
    let whatsappParametro = parametros?.whatsapp || '';
    let telefonoParametro = parametros?.telefono || '';

    setLogo(imgLogo);
    setInstagram(instagramParametro);
    setWhatsapp(whatsappParametro);
    setTelefono(telefonoParametro);
    setEmail("estudio@hargouas.com.ar");

    if(marketing){
      setEmail("marketing@hargouas.com.ar");
      setLogo(imgLogoMarketing);
    }
  }, [])  

  return (
    <section>
      <footer className="row d-flex section__footer mt-1 bottom-0 footer">
          <div className="col-lg-4 col-sm-12 d-flex flex-column px-5 pt-5 gap-1">
              <h6>Encontranos en:</h6>
              <div className="d-flex justify-content-center align-items-center">
                  <FaLocationDot className="mx-1" size={24}></FaLocationDot>                  
                  <a className="text-start">Calle 18 N° 590, La Plata, Buenos Aires</a>                  
              </div>
              {/* <div className="d-flex flex-row gap-1 justify-content-center pt-2">
                <a href={instagram} target="_blank"><FaInstagram className="footer__icon mx-2" size={24}></FaInstagram></a>
                <a href="https://www.facebook.com" target="_blank"><FaFacebook className="footer__icon mx-2" size={24}></FaFacebook></a>
                <a href="https://www.tiktok.com/" target="_blank"><FaTiktok className="footer__icon mx-2" size={24}></FaTiktok></a>
              </div> */}
          </div>

          <div className="col-lg-4 col-sm-12 d-flex flex-column justify-content-start align-items-center pt-5">
              <a href=""><img src={logo} alt="" width={100}/></a>            
          </div>

          <div className="col-lg-4 col-sm-12 d-flex flex-column justify-content-start align-items-center py-5">
            <div className="d-flex flex-column align-items-start gap-3">
              <a href={`mailto:${email}`} target="_blank"><GrMail className="footer__icon mx-3" size={24}></GrMail>{email}</a>
              <a href="tel:+2213635161" target="_blank"><FaPhone  className="footer__icon mx-3" size={24}></FaPhone >221-3635161</a>
            </div>
          </div>
      </footer>
      <Copyright></Copyright>
    </section>
  )
}